import { connect } from 'react-redux'
import { compose } from 'redux'
import { push } from 'connected-react-router'
import toJS from '../../hoc/toJS'
import getData from '../../functions/getData'
import {
    PROGRAM_CLI_MOVIES_ITEMS,
    PROGRAM_MOVIEMAPPING_ITEMS,
    PROGRAM_PM_MOVIES_ITEMS,
    PROGRAM_TMDB_MOVIES_ITEMS,
    TMDB_SEARCH_RESULTS,
    TMDB_SEARCH_LOADING,
    TMDB_DETAILS,
    TMDB_LINK_LOADING,
} from '../../constants/state'
import {
    tmdbSearchRequest,
    tmdbDetailsRequest,
    tmdbMatchRequest,
    tmdbUnmatchRequest,
    tmdbClear,
} from '../../actions'
import PageTmdbLinkPage from '../../components/PageTmdbLink/present/PageTmdbLinkPage'

const mapStateToProps = (state, ownProps) => ({
    metaMoviePk: ownProps.match.params.metaMoviePk,
    movies: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    movieMappings: getData(state, PROGRAM_MOVIEMAPPING_ITEMS),
    pmMovies: getData(state, PROGRAM_PM_MOVIES_ITEMS),
    tmdbMovies: getData(state, PROGRAM_TMDB_MOVIES_ITEMS),
    searchResults: getData(state, TMDB_SEARCH_RESULTS),
    searchLoading: getData(state, TMDB_SEARCH_LOADING),
    details: getData(state, TMDB_DETAILS),
    linkLoading: getData(state, TMDB_LINK_LOADING),
    translationStrings: state.getIn(['translation', 'strings']),
    currentLang: state.getIn(['translation', 'currentLang']),
})

const mapDispatchToProps = (dispatch) => ({
    onSearch: (query, year, language) => dispatch(tmdbSearchRequest(query, year, language)),
    onSelectResult: (tmdbId, language) => {
        dispatch(tmdbDetailsRequest(tmdbId, language))
    },
    onMatch: (metaMoviePk, tmdbMoviePk, metaMovie, from, pmMovie, tmdbMovieData) =>
        dispatch(tmdbMatchRequest(metaMoviePk, tmdbMoviePk, metaMovie, from, pmMovie, tmdbMovieData)),
    onUnmatch: (metaMoviePk, from) => dispatch(tmdbUnmatchRequest(metaMoviePk, from)),
    onNavigate: (path) => dispatch(push(path)),
    onClear: () => dispatch(tmdbClear()),
})

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(PageTmdbLinkPage)
